@if (show()) {
<section #tooltipRef @fadeInOut role="tooltip" [attr.aria-hidden]="!show()"
    [ngStyle]="{ transform: 'translate(' + position().left + 'px, ' + position().top + 'px)'}"
    [class.absolute]="!fixed()"
    [class.fixed]="fixed()"
    class="pointer-events-none z-50 top-0 left-0 transition-transform duration-100 h-fit bg-background border-1 border-border-solid border-radius-6 dropshadow-sm py-[16px] px-[24px] w-fit flex gap-[7px] shadow-xl">

    @if (color()) {
    <div class="h-auto min-w-[4px] w-[4px] rounded-[20px]" [style.backgroundColor]="color()"></div>
    }
    <div class="flex flex-col gap-[8px]">
        @if (tooltipTitle()) {
        <h5 class="content-semibold text-card-foreground leading-[24px]">{{tooltipTitle() | translate }}</h5>
        }

        <div class="flex flex-col gap-[4px]">
            @for (item of content(); track $index) {
            <div class="flex gap-[60px] items-center">
                <div class="flex gap-[8px] items-center">
                @if (item.color) {
                <!-- Colored marker. On dashed series (`item.dashed`), it
                     renders a 2×2 checker — opposite quadrants (TL+BR) with
                     `item.color`, the other two (TR+BL) with
                     `var(--border-inverted)` — visually mirroring the dashed
                     reference line on the chart. A smaller border-radius
                     (`2px`) helps keep the corners legible on the small
                     quadrants. -->
                @if (item.dashed) {
                <div class="min-w-[13px] w-[13px] h-[13px] rounded-[2px] overflow-hidden grid grid-cols-2 grid-rows-2" [ngClass]="{ 'dark': isDarkColorMode() }">
                  <div [style.background]="item.color"></div>
                  <div style="background: var(--border-inverted)"></div>
                  <div style="background: var(--border-inverted)"></div>
                  <div [style.background]="item.color"></div>
                </div>
                } @else {
                <div class="min-w-[13px] w-[13px] h-[13px] rounded-[2px]" [style.backgroundColor]="item.color" [ngClass]="{ 'dark': isDarkColorMode() }"></div>
                }
                }

                @if (item.iconLeft) {
                <div class="min-w-[20px] w-[20px] h-[20px] flex items-center justify-center" aria-hidden="true">
                    <i
                        class="fi fi-rr-{{ item.iconLeft }} !leading-[16px] !text-[16px] !h-[16px] block text-muted-foreground"></i>
                </div>
                }

                @if (item.label) {
                <p class="content-regular text-muted-foreground leading-[24px]" [attr.aria-label]="item.label">{{item.label | translate }}</p>
                }
                </div>

                @if (item.value) {
                <span class="content-semibold text-card-foreground leading-[24px] ml-auto">{{item.value}}</span>
                }

                @if (item.iconRight) {
                <div class="min-w-[20px] w-[20px] h-[20px] flex items-center justify-center" aria-hidden="true">
                    <i
                        class="fi fi-rr-{{ item.iconRight }} !leading-[16px] !text-[16px] !h-[16px] block text-muted-foreground"></i>
                </div>
                }
            </div>
            }
        </div>
    </div>
</section>
}